import AddIcon from "../icons/AddIcon";

import { Fragment } from "react";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import NextImage from "../global/NextImage";
import { validateImgSrc } from "@/utils/global";

const BundleProducts = ({ product, setOpen, t }) => {
  const productInStock =
    product?.stock?.qty >= 0 || product?.stock?.is_in_stock == true;
  // const bundleDiscountProducts = product?.ulmod_bundles
  //   ?.map((o) => o?.product_links)
  //   .flat();
  console.log(product?.ulmod_bundles);
  // const savings = bundleDiscountProducts.reduce((agg, curr) => {
  //   return (
  //     agg + curr.prices_with_tax.original_price - curr.prices_with_tax.price
  //   );
  // }, 0);

  return (
    <section className="max-sm:border max-sm:rounded-md max-sm:p-2">
      <div className="flex items-center gap-2">
        {/* <p className="text-[15px] max-sm:text-xs">{t("Saving")} :</p> */}
        <p className="font-bold text-[15px] max-sm:text-xs">
          {t("Instant Saving Available")}
        </p>
      </div>
      <section className="flex items-center gap-6 mt-1 overflow-x-auto">
        <div className="flex items-center gap-3 mt-1">
          <Fragment>
            <NextImage
              src={validateImgSrc(product?._media_?.image?.at(0)?.image)}
              className="object-contain w-9 sm:size-11"
              alt="Bundle Img!"
              width={44}
              height={44}
            />
            <AddIcon
              fill={"#a6276a"}
              className="size-4 last:hidden text-primary-900"
            />
          </Fragment>
        </div>
        <AddIcon className="size-4 last:hidden" />
        <div className="flex items-center gap-3 mt-1">
          {product?.ulmod_bundles
            ?.at(0)
            ?.product_links?.slice(0, 1)
            .map((p) => (
              <Fragment key={uuidv4()}>
                <NextImage
                  src={validateImgSrc(p?._media_?.image?.at(0)?.image)}
                  className="object-contain w-9 sm:size-11"
                  alt="Bundle Img!"
                  width={44}
                  height={44}
                />
              </Fragment>
            ))}
        </div>
        <div className="flex flex-col gap-2 text-xs bg-white">
          {/* <span className="whitespace-nowrap">Save Up To {savings} SR</span> */}
          <button
            onClick={() => {
              productInStock
                ? setOpen(true)
                : toast.error(t("Parent product is out of stock"));
            }}
            className="border border-[#4A61A7] font-bold rounded-md text-[#4A61A7] p-1.5 sm:p-2"
          >
            {t("Build Bundle")}
          </button>
        </div>
      </section>
    </section>
  );
};

export default BundleProducts;
